import { useRouter } from 'next/router';

// Utils
import MicroModal from 'micromodal';
import { omit } from 'lodash';
import modalConfig from '../utils/modalConfig';
import { useAppContext } from '../store/AppContext';

const useReplaceCartFromUrl = () => {
  const router = useRouter();
  const [{ players }, stateDispatch] = useAppContext();

  const handleKeepOngoingCart = () => {
    MicroModal.close('modal-replace-cart');
  };

  const handleReplaceCartConfirm = (setIsLoading = null) => {
    if (setIsLoading) setIsLoading(true);

    // reset previous cart
    stateDispatch({ type: 'RESET_BOOKING' });

    // reload the page without the cart=replace param
    router.push({
      pathname: router.pathname,
      query: omit(router.query, 'cart'),
    });
  };

  const handleReplaceCartFromUrl = () => {
    // check if URL has the replace param + check if user already has an ongoing cart
    const hasUrlReplaceParam = router?.query?.cart === 'replace';
    const hasUserAnOngoingCart = players?.length > 0;

    // if user already has an going cart
    if (hasUrlReplaceParam && hasUserAnOngoingCart) {
      MicroModal.show('modal-replace-cart', modalConfig);
    }
  };

  return {
    handleKeepOngoingCart,
    handleReplaceCartConfirm,
    handleReplaceCartFromUrl,
  };
};

export default useReplaceCartFromUrl;
